import { render, staticRenderFns } from "./EmbedManajemenToko.vue?vue&type=template&id=6229840a&scoped=true&"
import script from "./EmbedManajemenToko.vue?vue&type=script&lang=js&"
export * from "./EmbedManajemenToko.vue?vue&type=script&lang=js&"
import style0 from "./EmbedManajemenToko.vue?vue&type=style&index=0&id=6229840a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6229840a",
  null
  
)

export default component.exports